import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable()
export class AdminCentralActions {

    static getResources = createAction('[Admin:Central:Resources] Get Resources ', props<{userId: any}>());
    static getResourcesSuccess = createAction('[Admin:Central:Resources] Get Resources success',
        props<{ resources: Array<any> }>());
}
